import apcApi from "./api/apcApi";
import { geoPolData } from "./registration/config/geoPolData";

// export const getGeoPolData = (setGeoPolDataAction) => new Promise((resolve, reject) => { 
//     const headers = {
//     "Cache-Control": "no-cache",
//     'Authorization':'Bearer '+window.adobeIMS.getAccessToken().token,
//     'x-api-key':"exchange_spr"
//     }
//     apcApi.get('/api/v1/apc/country',{headers})
//     .then(response => {
//         const processedData = {};
//         response.data?.forEach((element) => {
//             processedData[element["_id"]] = element.counties;
//         })
//         setGeoPolDataAction(geoPolData);
//         resolve(response.data);
//     }).catch(error => {
//         reject(error);
//     });
//   });

export const getGeoPolData = (setGeoPolDataAction) =>  { 
    setGeoPolDataAction(geoPolData);
};